<template>
  <div class="tw-mx-16 tw-my-8">
    You ({{storeState.settings.user.me.email}}) don't have access to this data, 
    contact your admin to get access or 
    <a @click="logoutUser">logout if you're
    logged in with the wrong account.</a> 
    
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import { store } from '../store.js';
// import CmdK from './CmdK'
// Vue.component('cmd-k', CmdK)


export default {
  created() {
  },
  mounted() {
    this.checkLogin();
    window.addEventListener("message", receiveMessage, false);
    var self = this
    function receiveMessage(event) {
      if (event.origin.includes("seekwell")) {
        console.log('receiveMessage: ', event)
        setTimeout(() => {
          self.hideIframe = false
          self.storeState.loading = false
        }, 5000);
        if (event.data && event.data.loginMessage) {
          console.log('logged in: ', event.data)
          self.storeState.sessionId = event.data.session_id || event.data.sessionId
          localStorage.setItem('sessionId', self.storeState.sessionId);
          self.$parent.getUserData()
          self.$router.push({ path: '/' })
        }
        if (event.data && event.data.loggedOut) {
          self.hideIframe = false
          self.storeState.loading = false
        }
      }
    }
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      hideIframe: true,
      db: false,
      cmdkActive: false,
      searchTerm: '',
      searchIn: this.$parent.search,
      searchResults: this.$parent.search,
      consumedOn: new Date().toISOString().substr(0, 10),
      consumedOnCal: false,
      addingFood: false,
      removingFood: false,
      expanded: [],
      checked: [],
      amount: '',
      userEntries: [],
      userEntriesHeader: [], 
      loadingUserData: false,
      loading: true,
      selectedFood: false,
      unit: 'g',
      headers: [],
      foodFacts: [],
      amountRules: [
        value => !!value || 'Required.',
        value => !isNaN(value) || 'Enter a number'
      ],
    };
  },
  components: {
  },
  watch: {
  },
  methods: {
    logoutUser() {
      let url = 'https://seekwell.io/logout'
      window.open(url, '_blank');
      // let url2 = 'https://seekwell.ngrok.io/logout'
      // window.open(url2, '_blank');
      localStorage.removeItem('sessionId');
      this.storeState.loading = true
      this.storeState.cmdkActive = false
      setTimeout(() => {
        this.storeState.loading = false
        this.$router.push({ path: '/login' }).catch(err => console.error(err))
      }, 3000);
      // win.focus();
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `https://seekwell.ngrok.io${path}`
      }
      return  `https://seekwell.io${path}`
    },
    checkLogin() {
      console.log('checkLogin...')
      if (!store.state.doLogin && window.location.hostname === 'localhost') {
        console.log('checkLogin triggered...')
        store.state.loading = false
        //var localJ = require('../../../../localVue.json');
        //store.state.sessionId = localJ.sessionId
        this.$parent.getUserData()
        this.$router.push({ path: '/' })
      }
    }
  },
};
</script>

<style>
.code {
  display: inline;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.hide {
  display: none;
}
</style>